import { SessionService } from '@shared/core';
import { Injectable } from '@angular/core';
import { APP, AUTH, PROFILE, SESSION } from '../actions/index';
import { AppInitAction } from '../actions/app-actions';
import {
	SessionDestroyAction,
	SessionInitAction,
	SessionReloadFailureAction,
	SessionReloadSuccessAction,
	SessionStartServiceAction,
	SessionStateChangeAction
} from '../actions/session-actions';
import { Action } from '../action';
import { initialState } from '../reducers/session-reducer';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, map, mergeMap, pairwise, startWith, switchMap, take } from 'rxjs/operators';

@Injectable()
export class SessionEffects {
	@Effect()
	appInit$: Observable<Action> = this.actions$.pipe(
		ofType<AppInitAction>(APP.INIT),
		mergeMap(action => [new SessionStartServiceAction(null, action.correlationId)])
	);
	@Effect()
	sessionReload$: Observable<Action> = this.actions$.pipe(
		ofType<Action>(SESSION.RELOAD, AUTH.UPDATE_EMAIL_SUCCESS, AUTH.UPDATE_PASSWORD_SUCCESS, PROFILE.UPDATE_SUCCESS),
		switchMap(action =>
			this.session.reload().pipe(
				take(1),
				mergeMap(state => [
					new SessionReloadSuccessAction(state, action.correlationId),
					new SessionStateChangeAction(state, action.correlationId)
				]),
				catchError(e => of(new SessionReloadFailureAction(e, action.correlationId)))
			)
		)
	);
	@Effect()
	sessionStateChange$: Observable<Action> = this.actions$.pipe(
		startWith(new SessionStateChangeAction(initialState, new Date().getTime())),
		ofType<SessionStateChangeAction>(SESSION.STATE_CHANGE),
		pairwise(),
		switchMap(([a, b]) => {
			if (!a.payload.uid && b.payload.uid) {
				return of(new SessionInitAction(null, b.correlationId));
			}
			if (a.payload.uid && !b.payload.uid) {
				return of(new SessionDestroyAction(null, a.correlationId));
			}

			return EMPTY;
		})
	);
	@Effect()
	startService$: Observable<Action> = this.actions$.pipe(
		ofType<SessionStartServiceAction>(SESSION.START_SERVICE),
		switchMap(action => this.session.start().pipe(map(state => new SessionStateChangeAction(state, action.correlationId))))
	);

	constructor(
		private actions$: Actions,
		private store: Store<any>,
		private session: SessionService
	) {}
}
